import { render } from "./InternationalCurrencyField.vue?vue&type=template&id=3f4d1793"
import script from "./InternationalCurrencyField.vue?vue&type=script&lang=js"
export * from "./InternationalCurrencyField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"InternationalCurrencyField.vue"]])

export default __exports__